var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgeVerificationIdCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 71,
    viewBox: "0 0 104 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.47 7.86829H91.5305C94.2207 7.86829 96.4219 10.0694 96.4219 12.7597V57.7058C96.4219 60.3961 94.2208 62.5972 91.5305 62.5972H12.47C9.77978 62.5972 7.57861 60.3961 7.57861 57.7058V12.7597C7.57865 10.0694 9.77978 7.86829 12.47 7.86829Z",
    fill: "#F7EAE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4698 7.86829H91.5303C93.5847 7.86829 95.3538 9.15194 96.0753 10.9569H7.9248C8.6463 9.15194 10.4154 7.86829 12.4698 7.86829Z",
    fill: "#EDCBB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.47 7.86829H45.9387V62.5972H12.47C9.77978 62.5972 7.57861 60.3961 7.57861 57.7058V12.7597C7.57865 10.0694 9.77978 7.86829 12.47 7.86829Z",
    fill: "#FFD1B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4698 7.86829H45.9385V10.9568H7.9248C8.64634 9.15194 10.4154 7.86829 12.4698 7.86829Z",
    fill: "#DEA07A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.177 23.8201C53.623 23.8201 53.1738 23.371 53.1738 22.817C53.1738 22.263 53.623 21.8138 54.177 21.8138H77.117C77.671 21.8138 78.1201 22.263 78.1201 22.817C78.1201 23.371 77.671 23.8201 77.117 23.8201H54.177Z",
    fill: "#A35641"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.177 32.0973C53.623 32.0973 53.1738 31.6482 53.1738 31.0942C53.1738 30.5402 53.623 30.0911 54.177 30.0911H61.7448C62.2989 30.0911 62.748 30.5402 62.748 31.0942C62.748 31.6482 62.2989 32.0973 61.7448 32.0973H54.177Z",
    fill: "#A35641"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.177 40.3746C53.623 40.3746 53.1738 39.9254 53.1738 39.3714C53.1738 38.8174 53.623 38.3683 54.177 38.3683H89.9271C90.4811 38.3683 90.9302 38.8174 90.9302 39.3714C90.9302 39.9254 90.4811 40.3746 89.9271 40.3746H54.177Z",
    fill: "#A35641"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.177 48.6518C53.623 48.6518 53.1738 48.2027 53.1738 47.6486C53.1738 47.0946 53.623 46.6455 54.177 46.6455H71.1258C71.6798 46.6455 72.1289 47.0946 72.1289 47.6486C72.1289 48.2027 71.6798 48.6518 71.1258 48.6518H54.177Z",
    fill: "#A35641"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9895 23.8201C80.4355 23.8201 79.9863 23.371 79.9863 22.817C79.9863 22.263 80.4355 21.8138 80.9895 21.8138H89.927C90.481 21.8138 90.9301 22.263 90.9301 22.817C90.9301 23.371 90.481 23.8201 89.927 23.8201H80.9895Z",
    fill: "#A35641"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7224 32.0973C64.1684 32.0973 63.7192 31.6482 63.7192 31.0942C63.7192 30.5402 64.1684 30.0911 64.7224 30.0911H77.5899C78.144 30.0911 78.5931 30.5402 78.5931 31.0942C78.5931 31.6482 78.144 32.0973 77.5899 32.0973H64.7224Z",
    fill: "#A35641"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3591 32.0973C81.8051 32.0973 81.356 31.6482 81.356 31.0942C81.356 30.5402 81.8051 30.0911 82.3591 30.0911H89.9269C90.4809 30.0911 90.9301 30.5402 90.9301 31.0942C90.9301 31.6482 90.4809 32.0973 89.9269 32.0973H82.3591Z",
    fill: "#A35641"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6897 48.6518C74.1356 48.6518 73.6865 48.2027 73.6865 47.6486C73.6865 47.0946 74.1356 46.6455 74.6897 46.6455H89.9272C90.4812 46.6455 90.9303 47.0946 90.9303 47.6486C90.9303 48.2027 90.4812 48.6518 89.9272 48.6518H74.6897Z",
    fill: "#A35641"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80887 11.5534C2.80887 12.329 2.18006 12.9578 1.40443 12.9578C0.628806 12.9578 0 12.329 0 11.5534V1.40443C0 0.628806 0.628806 0 1.40443 0H13.4764C14.2521 0 14.8809 0.628806 14.8809 1.40443C14.8809 2.18006 14.2521 2.80887 13.4764 2.80887H2.80887V11.5534Z",
    fill: "#FF0000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 11.5534C104 12.329 103.371 12.9579 102.596 12.9579C101.82 12.9579 101.191 12.329 101.191 11.5534V2.80887H90.5236C89.7479 2.80887 89.1191 2.18006 89.1191 1.40443C89.1191 0.628808 89.7479 0 90.5236 0H102.596C103.371 0 104 0.628808 104 1.40443V11.5534Z",
    fill: "#FF0000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 58.9121C0 58.1365 0.628806 57.5077 1.40443 57.5077C2.18006 57.5077 2.80887 58.1365 2.80887 58.9121V67.6567H13.4764C14.2521 67.6567 14.8809 68.2855 14.8809 69.0611C14.8809 69.8367 14.2521 70.4655 13.4764 70.4655H1.40443C0.628806 70.4655 0 69.8367 0 69.0611V58.9121Z",
    fill: "#FF0000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.191 58.9121C101.191 58.1365 101.82 57.5077 102.596 57.5077C103.371 57.5077 104 58.1365 104 58.9121V69.0611C104 69.8367 103.371 70.4655 102.596 70.4655H90.5236C89.7479 70.4655 89.1191 69.8367 89.1191 69.0611C89.1191 68.2854 89.7479 67.6566 90.5236 67.6566H101.191V58.9121Z",
    fill: "#FF0000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5631 38.9071C38.8739 34.5963 38.8739 27.6071 34.5631 23.2963C30.2523 18.9855 23.2631 18.9855 18.9523 23.2963C14.6416 27.6071 14.6416 34.5963 18.9523 38.9071C23.2631 43.2178 30.2523 43.2178 34.5631 38.9071Z",
    fill: "#A35641"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7584 30.292C28.3914 30.292 29.7232 28.9601 29.7232 27.3271C29.7232 25.6941 28.3914 24.3622 26.7584 24.3622C25.1253 24.3622 23.7935 25.6941 23.7935 27.3271C23.7935 28.9601 25.1254 30.292 26.7584 30.292Z",
    fill: "#F7EAE2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7583 31.9336C30.1585 31.9336 32.953 34.5256 33.2744 37.8414H20.2422C20.5636 34.5256 23.3581 31.9336 26.7583 31.9336Z",
    fill: "#F7EAE2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8275 47.5131C18.4951 47.5131 18.2256 47.2436 18.2256 46.9112C18.2256 46.5788 18.4951 46.3093 18.8275 46.3093H34.689C35.0214 46.3093 35.2909 46.5788 35.2909 46.9112C35.2909 47.2436 35.0214 47.5131 34.689 47.5131H18.8275Z",
    fill: "#A35641"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2884 51.0041C14.956 51.0041 14.6865 50.7346 14.6865 50.4022C14.6865 50.0698 14.956 49.8003 15.2884 49.8003H38.2284C38.5608 49.8003 38.8303 50.0698 38.8303 50.4022C38.8303 50.7346 38.5608 51.0041 38.2284 51.0041H15.2884Z",
    fill: "#A35641"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9071 14.3879H45.9071C46.1278 14.3879 46.3083 14.5685 46.3083 14.7892V55.6764C46.3083 55.897 46.1278 56.0776 45.9071 56.0776H45.9071C45.6864 56.0776 45.5059 55.897 45.5059 55.6764V14.7892C45.5059 14.5685 45.6864 14.3879 45.9071 14.3879Z",
    fill: "#A35641"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeVerificationIdCard);
export default __webpack_public_path__ + "static/media/age-verification-id-card.c40666e0eebb6beaeb3689cd90c81345.svg";
export { ForwardRef as ReactComponent };